module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/mres7-43fbfe97fcb1b9699625dbe6ee2bb3e5.jpg";